
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import './App.css';
import './assets/css/style.css';

//import Sidebar from './Components/Sidebar';
import Login from './Components/Login/Login';
import GetLocation from './Components/TestComponent/locationTest.js';
// import LoginForm from './Components/Login/LoginForm';
import './firebase.js';
import { fetchFirebaseToken } from "./firebase.js";
import Notification from './Notification.js';
import MaterialConsumeStatus from './Components/FaultRepairPageComponents/MaterialConsumeStatus';
import INASpage from './Components/DashboardPageComponents/INASpage';
import Dashboard from './Components/DashboardPageComponents/Dashboard';
import BusinessCardList from './Components/BusinessPageComponents/BusinessCardList';
import BroadbandCardList from './Components/BroadbandPageComponents/BroadbandCardList';
import FaultRepairCardList from './Components/FaultRepairPageComponents/FaultRepairCardList';
import FaultRepairAssignments from './Components/FaultRepairPageComponents/FaultRepairAssignments';
import FaultRepairAssignmentView from './Components/FaultRepairPageComponents/FaultRepairAssignmentView';
import Installation from './Components/InstallationPageComponents/Installation';
import InstallationProvisioning from './Components/InstallationPageComponents/InstallationProvisioning';

import InstallationProvisioningForm from './Components/InstallationPageComponents/InstallationProvisioningForm';
import InstallationWCRCompleted from './Components/InstallationPageComponents/InstallationWCRCompleted';
import ItemConsumption from './Components/InstallationPageComponents/ItemConsumption';
import AddEquipment from './Components/InstallationPageComponents/AddEquipment';
import ServiceConsumpton from './Components/InstallationPageComponents/ServiceConsumption';
import EditItemConsumption from './Components/InstallationPageComponents/EditItemConsumption';
import EditEquipmentConsumption from './Components/InstallationPageComponents/EditEquipmentConsumption';
import EditEquipmentConsumptionIR from './Components/InstallationPageComponents/EditEquipmentConsumptionIR';
import EditServiceConsumptios from './Components/InstallationPageComponents/EditServiceConsumptios'

import InstallationWCR from './Components/InstallationPageComponents/InstallationWCR';
import InstallationIR from './Components/InstallationPageComponents/InstallationIR';
import CustomerInfra from './Components/CustomerInfraPageComponents/CustomerInfra';
import CustomerInfraForm from './Components/CustomerInfraPageComponents/CustomerInfraForm';
import CustomerSR from './Components/CustomerSRpageComponents/CustomerSR';
import BussinessContactManagement from './Components/BusinessPageComponents/BusinessContactManagement';
import BusinessLead from './Components/BusinessPageComponents/BusinessLead';

import OpportunityForm from './Components/BroadbandPageComponents/OpportunityForm.js';
import Opportunity from './Components/BroadbandPageComponents/Opportunity.js';
import BusinessCAF from './Components/BusinessPageComponents/BusinessCAF';
import SafPage from './Components/BusinessPageComponents/SafPage';
import BusinessMyDashboard from './Components/BusinessPageComponents/BusinessMyDashboard';
import ContactsManagementForm from './Components/BusinessPageComponents/ContactsManagementForm';
import LeadDetailsForm from './Components/BusinessPageComponents/LeadDetailsForm';
import BroadbandContactManage from './Components/BroadbandPageComponents/BroadbandContactManage';
import BroadbandLead from './Components/BroadbandPageComponents/BroadbandLead';
import BroadbandCAF from './Components/BroadbandPageComponents/BroadbandCAF';
import BroadbandBuilding from './Components/BroadbandPageComponents/BroadbandBuilding';
import BroadbandDashboard from './Components/BroadbandPageComponents/BroadbandDashboard';
import BroadbandContactsManageForm from './Components/BroadbandPageComponents/BroadbandContactsManageForm';
import BroadbandLeadForm from './Components/BroadbandPageComponents/BroadbandLeadForm';
import FLRcreateCaf from './Components/BusinessPageComponents/FLRcreateCaf';
import BusinessNewContactManagement from './Components/BusinessPageComponents/BusinessNewContactManagement';
import NewContactForm from './Components/BusinessPageComponents/NewContactForm';
import BusinessCAFmanageForm from './Components/BusinessPageComponents/BusinessCAFmanageForm';
import BusinessCAFmanageFormDOC from './Components/BusinessPageComponents/BusinessCAFmanageFormDocument';
import BusinessSAFmanageForm from './Components/BusinessPageComponents/BusinessSAFmanageForm';
import BusinessSAFmanageFormDOC from './Components/BusinessPageComponents/BusinessSAFmanageFormDocument';
import BroadBandContactsManageUpdateForm from './Components/BroadbandPageComponents/BroadBandContactsManageUpdateForm';
import BroadbandCAFmanageForm from './Components/BroadbandPageComponents/BroadbandCAFmanageForm.js';
// import BroadbandCAFmanageFormDOC from './Components/BroadbandPageComponents/BroadbandCAFmanageFormDoc';
import FaultRepairDotSr from './Components/FaultRepairPageComponents/FaultRepairDotSr';
import FaultRepairViewSr from './Components/FaultRepairPageComponents/FaultRepairViewSr';
import YourAssignmentAddItem from './Components/FaultRepairPageComponents/YourAssignmentAddItem';
import MaterialConsumeNext from './Components/FaultRepairPageComponents/MaterialConsumeNext';
import EditMaterial from './Components/FaultRepairPageComponents/EditMaterial';
import TPFaultRepair from './Components/FaultRepairPageComponents/TPFaultRepair';

import FaultRepairAssignmentTpView from './Components/FaultRepairPageComponents/FaultRepairAssignmentTpView';

import MyComponent from './Components/TestComponent/MyComponent';
import AddEquipmentIR from './Components/InstallationPageComponents/AddEquipmentIR';
import EditItemConsumptionIR from './Components/InstallationPageComponents/EditItemConsumptionIR';
import EditServiceConsumptionIR from './Components/InstallationPageComponents/EditServiceConsumptionIR';
import ServiceConsumptionIR from './Components/InstallationPageComponents/ServiceConsumptionIR'
import BroadbandCAFmangeNewDoc from './Components/BroadbandPageComponents/BroadbandCAFmangeNewDoc';
import BusinessCafmangeNewDoc from './Components/BusinessPageComponents/BusinnessCafManageNewDoc';
import BusinessOpportunity from './Components/BusinessPageComponents/BusinessOportunity.js'
import BusinessOppotunityForm from './Components/BusinessPageComponents/BusinessOpportunityForm.js'
import BusinessMeetings from './Components/BusinessPageComponents/BusinessMeetings.js';

import BusinessCustomerLivePhoto from './Components/BusinessPageComponents/BusinessCustomerLivePhoto.js'
import BroadbandCustomerLivePhoto from './Components/BroadbandPageComponents/BroadbandCustomerLivePhoto.js'
import SellerLivePhotoV2 from './Components/BusinessPageComponents/SellerLivePhoto.js'
import CustomerLivePhotoV2 from './Components/BusinessPageComponents/CustomerLivePhoto.js'
import AnnotationDetails from './Public/AnnotationDetails.js'

import BusinessSitedetails from './Components/BusinessPageComponents/BusinessSitedetails';
import BusinessShowAllMeeting from './Components/BusinessPageComponents/BusinessShowAllMeeting.js';

// ---- Business Pg ----
import BusinessMeetingsPG from './Components/BusinessPageComponents/BusinessPgComponent/BusinessMeetingsPG.js'
import BusinessShowAllMeetingsPG from './Components/BusinessPageComponents/BusinessPgComponent/BusinessShowAllMeetingsPG.js'
import BusinessLeadFormPg from './Components/BusinessPageComponents/BusinessPgComponent/BusinessLeadFormPg.js'
import BusinessPgOpp from './Components/BusinessPageComponents/BusinessPgComponent/BusinessPgOpp.js'
import BusinessPgContactForm from './Components/BusinessPageComponents/BusinessPgComponent/BusinessPgContactForm';
import PriceCalculator from './Components/BusinessPageComponents/BusinessPgComponent/PriceCalculator.js';
import PurchaseOrder from './Components/BusinessPageComponents/BusinessPgComponent/PurchaseOrder.js';
import BusinessCardListPG from './Components/BusinessPageComponents/BusinessPgComponent/BusinessCardListPG.js';
import BusinessCardPG from './Components/BusinessPageComponents/BusinessPgComponent/BusinessCardPG.js';
import BusinessContactPg from './Components/BusinessPageComponents/BusinessPgComponent/BusinessContactPg.js';
import BusinessLeadPg from './Components/BusinessPageComponents/BusinessPgComponent/BusinessLeadPg.js';
import BusinessOpportunityPg from './Components/BusinessPageComponents/BusinessPgComponent/BusinessOpportunityPg.js';
import PriceCalculatorPG from './Components/BusinessPageComponents/BusinessPgComponent/PriceCalculatorPG.js';


// ---- Business Pro-Wifi menu----
import CardListProfi from './Components/DashboardPageComponents/CardListProfi.js';

// ---- Business Pro-Wifi ----
import BusinessProWifiMeetings from './Components/BusinessPageComponents/BusinessProWifiComponent/BusinessProWifiMeetings.js'
// import BusinessProWifiAllMeetings from './Components/BusinessPageComponents/BusinessProWifiComponent/BusinessProWifiAllMeetings.js'
import BusinessProWifiLeadForm from './Components/BusinessPageComponents/BusinessProWifiComponent/BusinessProWifiLeadForm.js'
import BusinessProWifiOpp from './Components/BusinessPageComponents/BusinessProWifiComponent/BusinessProWifiOpp.js'
import BusinessProWifiContactForm from './Components/BusinessPageComponents/BusinessProWifiComponent/BusinessProWifiContactForm';
// import PriceCalculatorProWifi from './Components/BusinessPageComponents/BusinessProWifiComponent/PriceCalculatorProWifi.js';
import AddProductProWifi from './Components/BusinessPageComponents/BusinessProWifiComponent/AddProductProWifi.js';
// import PurchaseOrderProWifi from './Components/BusinessPageComponents/BusinessProWifiComponent/PurchaseOrderProWifi.js';
import BusinessCardListProWiFi from "./Components/BusinessPageComponents/BusinessProWifiComponent/BusinessCardListProWifi.js"
import BusinessCardProWiFi from './Components/BusinessPageComponents/BusinessProWifiComponent/BusinessCardProwifi.js'
import BusinessContactProWifi from './Components/BusinessPageComponents/BusinessProWifiComponent/BusinessContactProWifi.js';
import BusinessLeadProWifi from './Components/BusinessPageComponents/BusinessProWifiComponent/BusinessLeadProWifi.js';
import BusinessOpportunityProWifi from './Components/BusinessPageComponents/BusinessProWifiComponent/BusinessOpportunityProWifi.js';
import BusinessShowAllMeetOffice from './Components/BusinessPageComponents/BusinessProWifiComponent/BussinessShowAllMeetOffice.js';
// import BusinessSitedetails from './Components/BusinessPageComponents/BusinessSitedetails';
import SelectProductProwifi from './Components/BusinessPageComponents/BusinessProWifiComponent/SelectProductProwifi.js';
import SelectProductSOHO from './Components/BusinessPageComponents/BusinessProWifiComponent/SelectProductSOHO.js';

//------ bdr -------
import BusinessBdrContactFormPg from './Components/BusinessPageComponents/BusinessBdrComponent/BusinessBdrContactFormPg.js';
import BusinessBdrContactFormOffice from './Components/BusinessPageComponents/BusinessBdrComponent/BusinessBdrContactFormOffice.js';
import BusinessBdrOfficeAllContact from './Components/BusinessPageComponents/BusinessBdrComponent/BusinessBdrOfficeAllContact.js';
import BusinessBdrPgAllContact from './Components/BusinessPageComponents/BusinessBdrComponent/BusinessBdrPgAllContact.js';
import BusinessMraCardList from './Components/BusinessPageComponents/BusinessBdrComponent/BusinessMraCardList.js';
import BusinessMeetingsMraOffice from './Components/BusinessPageComponents/BusinessBdrComponent/BusinessMeetingsMraOffice.js';
import BusinessMeetingsMraPg from './Components/BusinessPageComponents/BusinessBdrComponent/BusinessMeetingsMraPg.js';
import BusinessMraAllMeetings from './Components/BusinessPageComponents/BusinessBdrComponent/BusinessMraAllMeetings.js';
import BusinessMraContactFormHotel from './Components/BusinessPageComponents/BusinessBdrComponent/BusinessMraContactFormHotel.js';
import BusinessMraAllContactHotel from './Components/BusinessPageComponents/BusinessBdrComponent/BusinessMraAllContactHotel.js';
import BusinessMraHotelMeetings from './Components/BusinessPageComponents/BusinessBdrComponent/BusinessMraHotelMeetings.js';

// ---- Business Hotel ----
import BusinessCardListHotel from './Components/BusinessPageComponents/BusinessHotelComponent/BusinessCardListHotel.js';
import BusinessMeetingsHotel from './Components/BusinessPageComponents/BusinessHotelComponent/BusinessMeetingsHotel.js'

import BusinessCardHotel from './Components/BusinessPageComponents/BusinessHotelComponent/BusinessCardHotel.js';
import BusinessContactHotel from './Components/BusinessPageComponents/BusinessHotelComponent/BusinessContactHotel.js';
import BusinessContactFormHotel from './Components/BusinessPageComponents/BusinessHotelComponent/BusinessContactFormHotel.js';
import BusinessLeadHotel from './Components/BusinessPageComponents/BusinessHotelComponent/BusinessLeadHotel.js';
import BusinessLeadFormHotel from './Components/BusinessPageComponents/BusinessHotelComponent/BusinessLeadFormHotel.js'
import BusinessOpportunityHotel from './Components/BusinessPageComponents/BusinessHotelComponent/BusinessOpportunityHotel.js';
import BusinessOpportunityFormHotel from './Components/BusinessPageComponents/BusinessHotelComponent/BusinessOpportunityFormHotel.js'
import PriceCalculatorHotel from './Components/BusinessPageComponents/BusinessHotelComponent/PriceCalculatorHotel.js';
import PurchaseOrderHotel from './Components/BusinessPageComponents/BusinessHotelComponent/PurchaseOrderHotel.js';
import BusinessShowAllMeetHotel from './Components/BusinessPageComponents/BusinessHotelComponent/BussinessShowAllMeetHotel.js';

import BotResponseTableUI from './Components/TestComponent/BotResponseTableUI.js';
import AdminAccessPage from './Components/DashboardPageComponents/AdminAccess.js';
import TestComponent from './Components/TestComponent/TestComponent.js'
import InstallationCompareUI from './Components/InstalltionImageAdmin/InstallationCompareUI.js';



// RC details view
import DashboardForRCDetails from './Components/DashboardPageComponents/RcDetailsComponents/DashboardForRCDetails.js';
import RcDetailsCard from './Components/DashboardPageComponents/RcDetailsComponents/RcDetailsCard.js';
import WhatsappData from './Components/DashboardPageComponents/RcDetailsComponents/WhatsappData.js';
import UmpSrDetails from './Components/DashboardPageComponents/RcDetailsComponents/UmpSrDetails.js';


const App = () => {

  const navigate = useNavigate();

  useEffect(() => {
    const init = async () => {

      const userEmail = sessionStorage.getItem("userEmail")
      const userName = sessionStorage.getItem("userName")
      const password = sessionStorage.getItem("password")

      if (!userEmail || !userName || !password) {
        navigate("/")
        return
      }

      const token = await fetchFirebaseToken();
      // console.log("Firebase token initialized:", token);
    };
    init();
  }, []);

  return (
    <>

      {/* <BrowserRouter> */}
      <Notification />
      <Routes>

        <Route path="/" element={<Login />} />
        <Route path="/getLocation" element={<GetLocation />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/users/admin" element={<AdminAccessPage />} />
        <Route path="/inas" element={<INASpage />} />
        <Route path="/business" element={<BusinessCardList />} />
        <Route path="/broadband" element={<BroadbandCardList />} />
        <Route path="/installation" element={<Installation />} />
        <Route path="/installationprovisioning" element={<InstallationProvisioning />} />
        <Route path="/InstallationWCRCompleted" element={<InstallationWCRCompleted />} />
        <Route path="/installationprovisioningform" element={<InstallationProvisioningForm />} />

        <Route path="/crm/broadbandCustomerLivePhoto" element={<BroadbandCustomerLivePhoto />} />
        <Route path="/crm/businessCustomerLivePhoto" element={<BusinessCustomerLivePhoto />} />
        <Route path="/crm/customerLivePhoto" element={<CustomerLivePhotoV2 />} />
        <Route path="/crm/sellerLivePhoto" element={<SellerLivePhotoV2 />} />
        <Route path="/crm/annotation" element={<AnnotationDetails />} />


        <Route path="/ItemConsumption" element={<ItemConsumption />} />
        <Route path="/addEquipment" element={<AddEquipment />} />
        <Route path="/addEquipmentIR" element={<AddEquipmentIR />} />
        <Route path="/serviceConsumpton" element={<ServiceConsumpton />} />
        <Route path="/serviceConsumptionIR" element={<ServiceConsumptionIR />} />
        <Route path="/editItemConsumption" element={<EditItemConsumption />} />
        <Route path="/editItemConsumptionIR" element={<EditItemConsumptionIR />} />
        <Route path="/editEquipmentConsumptionIR" element={<EditEquipmentConsumptionIR />} />
        <Route path="/editEquipmentConsumption" element={<EditEquipmentConsumption />} />
        <Route path="/editServiceConsumptios" element={<EditServiceConsumptios />} />
        <Route path="/editServiceConsumptionIR" element={<EditServiceConsumptionIR />} />

        <Route path="/installationWCR" element={<InstallationWCR />} />
        <Route path='/installationIR' element={<InstallationIR />} />
        <Route path="/faultRepair" element={<FaultRepairCardList />} />
        <Route path="/faultRepairAssignments" element={<FaultRepairAssignments />} />
        <Route path="/faultRepairAssignmentView" element={<FaultRepairAssignmentView />} />
        <Route path="/customerInfra" element={<CustomerInfra />} />
        <Route path="/customerInfraForm" element={<CustomerInfraForm />} />
        <Route path="/falutRepairTp" element={<TPFaultRepair />} />

        <Route path="/faultRepairAssignmentTpView" element={<FaultRepairAssignmentTpView />} />


        <Route path="/customerSR" element={<CustomerSR />} />
        <Route path="/businessMyDashboard" element={<BusinessMyDashboard />} />
        <Route path="/contactManagement" element={<BussinessContactManagement />} />
        <Route path="/businessLead" element={<BusinessLead />} />
        <Route path="/opportunity" element={<Opportunity />} />
        <Route path="/opportunityForm" element={<OpportunityForm />} />
        <Route path="/businessCafmangeNewDoc" element={<BusinessCafmangeNewDoc />} />
        <Route path="/businessSitedetails" element={<BusinessSitedetails />} />
        <Route path='/businessMeetings' element={<BusinessMeetings />} />
        <Route path='/businessShowAllMeeting' element={<BusinessShowAllMeeting />} />


        {/* ---- Business PG ---- */}
        <Route path="/businessCardListPG" element={<BusinessCardListPG />} />
        <Route path="/businessCardPG" element={<BusinessCardPG />} />
        <Route path="/businessContactPg" element={<BusinessContactPg />} />
        <Route path="/businessLeadPg" element={<BusinessLeadPg />} />
        <Route path="/businessOpportunityPg" element={<BusinessOpportunityPg />} />
        <Route path='/businessMeetingPg' element={<BusinessMeetingsPG />} />
        <Route path='/businessPgContactForm' element={<BusinessPgContactForm />} />
        <Route path='/businessShowAllMeetingsPg' element={<BusinessShowAllMeetingsPG />} />
        <Route path='/businessPgLeadForm' element={<BusinessLeadFormPg />} />
        <Route path="/businessPgOpp" element={<BusinessPgOpp />} />
        <Route path="/priceCalculator" element={<PriceCalculator />} />
        <Route path="/purchaseOrder" element={<PurchaseOrder />} />
        <Route path="/priceCalculatorPG" element={<PriceCalculatorPG />} />


        <Route path="/cardListProfi" element={<CardListProfi />} />

        {/* ---- Business Pro Wi-Fi ---- */}
        <Route path="/businessCardProWiFi" element={<BusinessCardProWiFi />} />
        <Route path="/businessCardListProWiFi" element={<BusinessCardListProWiFi />} />
        <Route path="/businessContactProWifi" element={<BusinessContactProWifi />} />
        <Route path="/businessLeadProWifi" element={<BusinessLeadProWifi />} />
        <Route path="/businessOpportunityProWifi" element={<BusinessOpportunityProWifi />} />
        <Route path='/businessProWifiMeetings' element={<BusinessProWifiMeetings />} />
        <Route path='/businessProWifiContactForm' element={<BusinessProWifiContactForm />} />
        {/* <Route path='/businessProWifiAllMeetings' element={<BusinessProWifiAllMeetings />} /> */}
        <Route path='/businessProWifiLeadForm' element={<BusinessProWifiLeadForm />} />
        <Route path="/businessProWifiOpp" element={<BusinessProWifiOpp />} />
        {/* <Route path="/priceCalculatorProWifi" element={<PriceCalculatorProWifi />} /> */}
        <Route path="/addProductProWifi" element={<AddProductProWifi />} />
        {/* <Route path="/purchaseOrderProWifi" element={<PurchaseOrderProWifi />} /> */}
        <Route path="/businessShowAllMeetOffice" element={<BusinessShowAllMeetOffice />} />
        <Route path="/selectProductProwifi" element={<SelectProductProwifi />} />
        <Route path="/selectProductSOHO" element={<SelectProductSOHO />} />



        {/* ---- Business BDR  ---- */}
        <Route path="/businessBdrContactFormPg" element={<BusinessBdrContactFormPg />} />
        <Route path="/businessBdrContactFormOffice" element={<BusinessBdrContactFormOffice />} />
        <Route path="/businessBdrOfficeAllContact" element={<BusinessBdrOfficeAllContact />} />
        <Route path="/businessBdrPgAllContact" element={<BusinessBdrPgAllContact />} />
        <Route path="/businessMraCardList" element={<BusinessMraCardList />} />
        <Route path="/businessMeetingsMraOffice" element={<BusinessMeetingsMraOffice />} />
        <Route path="/businessMeetingsMraPg" element={<BusinessMeetingsMraPg />} />
        <Route path="/businessMraAllMeetings" element={<BusinessMraAllMeetings />} />
        <Route path="/businessMraContactFormHotel" element={<BusinessMraContactFormHotel />} />
        <Route path="/businessMraAllContactHotel" element={<BusinessMraAllContactHotel />} />
        <Route path="/businessMraHotelMeetings" element={<BusinessMraHotelMeetings />} />

        {/* ---- Business Hotel ---- */}
        <Route path="/businessCardListHotel" element={<BusinessCardListHotel />} />
        <Route path="/businessCardHotel" element={<BusinessCardHotel />} />
        <Route path="/businessMeetingsHotel" element={<BusinessMeetingsHotel />} />

        <Route path="/businessContactHotel" element={<BusinessContactHotel />} />
        <Route path="/businessContactFormHotel" element={<BusinessContactFormHotel />} />
        <Route path="/businessLeadHotel" element={<BusinessLeadHotel />} />
        <Route path="/businessLeadFormHotel" element={<BusinessLeadFormHotel />} />
        <Route path="/businessOpportunityHotel" element={<BusinessOpportunityHotel />} />
        <Route path="/businessOpportunityFormHotel" element={<BusinessOpportunityFormHotel />} />
        <Route path="/priceCalculatorHotel" element={<PriceCalculatorHotel />} />
        <Route path="/purchaseOrderHotel" element={<PurchaseOrderHotel />} />
        <Route path="/businessShowAllMeetHotel" element={<BusinessShowAllMeetHotel />} />


        <Route path="/businessOpportunity" element={<BusinessOpportunity />} />
        <Route path='/businessOpportunityForm' element={<BusinessOppotunityForm />} />
        <Route path="/businessCaf" element={<BusinessCAF />} />
        <Route path='/saf' element={<SafPage />} />
        <Route path="/contactsManagementForm" element={<ContactsManagementForm />} />
        <Route path="/businessLeadForm" element={<LeadDetailsForm />} />
        <Route path="/broadbandContactManage" element={<BroadbandContactManage />} />
        <Route path='/broadbandLead' element={<BroadbandLead />} />
        <Route path='/broadbandCAF' element={<BroadbandCAF />} />
        <Route path='/broadbandBuilding' element={<BroadbandBuilding />} />
        <Route path='/broadbandDashboard' element={<BroadbandDashboard />} />
        <Route path='/broadbandContactsForm' element={<BroadbandContactsManageForm />} />
        <Route path='/broadbandContactsUpdateForm' element={<BroadBandContactsManageUpdateForm />} />
        <Route path='/broadbandLeadForm' element={<BroadbandLeadForm />} />
        <Route path='/flrcreate' element={<FLRcreateCaf />} />
        <Route path='/newContact' element={<BusinessNewContactManagement />} />
        <Route path='/newcontactform' element={<NewContactForm />} />
        <Route path='/businessCAFmanageForm' element={<BusinessCAFmanageForm />} />
        <Route path='/businessCAFmanageFormDOC' element={<BusinessCAFmanageFormDOC />} />
        <Route path='/businessSAFmanageForm' element={<BusinessSAFmanageForm />} />
        <Route path='/businessSAFmanageFormDOC' element={<BusinessSAFmanageFormDOC />} />
        <Route path='/broadbandCAFmanageForm' element={<BroadbandCAFmanageForm />} />
        {/* <Route path='/broadbandCAFmanageFormDOC' element={<BroadbandCAFmanageFormDOC/>}/> */}
        <Route path='/broadbandCAFmangeNewDoc' element={<BroadbandCAFmangeNewDoc />} />


        <Route path="/faultRepairDotSr" element={<FaultRepairDotSr />} />
        <Route path="/faultRepairViewSr" element={<FaultRepairViewSr />} />
        <Route path="/yourAssignmentAddItem" element={<YourAssignmentAddItem />} />
        <Route path="/materialConsumeNext" element={<MaterialConsumeNext />} />
        <Route path='/materialConsumeStatus' element={<MaterialConsumeStatus />} />
        <Route path="/editMaterial" element={<EditMaterial />} />
        <Route path="/MyComponent" element={<MyComponent />} />



        {/* rc details Routes */}
        <Route element={<DashboardForRCDetails />}>
          <Route path="/dashboradrc" element={<RcDetailsCard />} />
          <Route path="/RcDetailsCard" element={<RcDetailsCard />} />
          <Route path="/umpSrDetails" element={<UmpSrDetails />} />
          <Route path="/whatsappData" element={<WhatsappData />} />
        </Route>

        {/* <Route path="/installationCompareUI" element={<InstallationCompareUI />} /> */}
        <Route path="/testComponent" element={<TestComponent />} />
        <Route path="/botResponseTableUI" element={<BotResponseTableUI />} />
      </Routes>
      {/* </BrowserRouter> */}
    </>
  );
};

export default App;
